import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Divider, Link } from '@mui/material';
import InputField from '../common/InputField/InputField';
import styles from './styles';
import { ForgotPasswordProps } from './types';
import FormButton from '../common/FormButton';

const ForgotPassword = ({
    handleSubmit,
    showError = false,
    handleInput,
    credentials,
    submitting,
}: ForgotPasswordProps) => {
    return (
        <Box>
            <Link id="forgot_password_lessthan_icon" href="/" sx={styles.backBtn}>
                {'<'}
            </Link>
            <Typography id="forgot_password-title" data-testid="diathrive_title" sx={styles.subTitle} component="div">
                Reset My <Typography sx={styles.title}>Password</Typography>
            </Typography>
            <Typography id="forgot_password_text" sx={styles.description} component="div">
                Enter your registered email below so that Diathrive send you a link to reset your password.
            </Typography>
            <Divider sx={styles.divider} />
            <Box component="form" noValidate onSubmit={handleSubmit}>
                <InputField
                    required
                    id="email"
                    label="Email"
                    type="text"
                    name="email"
                    placeholder="Type here..."
                    onChange={handleInput}
                    error={showError}
                    value={credentials.email}
                />
                {showError ? (
                    <Typography id="forgot_password_error_text" sx={styles.error_message}>
                        It doesn't look like that email is associated with an account. Please check your credentials and
                        try again.
                    </Typography>
                ) : null}

                <FormButton
                    id="send_reset_link"
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={styles.sendLink_Btn}
                    submitting={submitting}
                >
                    Send Reset Link
                </FormButton>
            </Box>
        </Box>
    );
};

export default ForgotPassword;
